/**
 * Mensagem informativa exibida nas abas filtradas pela clínica logada.
 */
export function getFollowUpOrganizationFilterMessage(
  organizationName?: string,
): string {
  const clinicLabel = organizationName?.trim() || "clínica selecionada";

  return `Exibindo apenas registros realizados pela clínica ${clinicLabel}. Registros de outras clínicas não aparecem nesta lista. Clique no ícone do WhatsApp para enviar uma mensagem de acompanhamento ao paciente.`;
}

/**
 * Normaliza texto para comparação em filtros locais (case-insensitive, sem acentos).
 */
export function normalizeSearchText(value: string): string {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/**
 * Verifica se o requester pertence à organização logada.
 * Formato esperado: PractitionerRole/{organizationId}-{oid}-{professionalId}
 */
export function isRequesterFromOrganization(
  requesterReference: string | undefined,
  organizationId: string | undefined,
): boolean {
  if (!requesterReference || !organizationId) return false;

  const roleId = requesterReference.includes("/")
    ? requesterReference.split("/")[1]
    : requesterReference;

  return roleId.includes(organizationId);
}

/**
 * Filtra entradas mantendo apenas registros da organização logada.
 */
export function filterEntriesByOrganization<T>(
  entries: T[] | undefined,
  organizationId: string | undefined,
  getRequesterRef: (entry: T) => string | undefined,
): T[] {
  if (!entries?.length) return [];

  return entries.filter((entry) =>
    isRequesterFromOrganization(getRequesterRef(entry), organizationId),
  );
}
